<div class="container-fluid p-0" id="dashboard" *ngIf="!showFullScreenSlideShow">
  <div class="body_wrap dashboard_body m-scroll">
    <!-- <div class="sticky-top sticky-offset">
      <div class="top_menu">
        <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button>
      </div>
    </div> -->

    <div class="dash_base" (wheel)="onMouseWheel($event)" *ngIf="!message">
      <div class="">
        <section class="mt-2">
          <div class="container custom-container">
            <div class="whiteWrap">
              <div class="titleWrap m-container">
                <div class="nav-container">
                  <div class="row">
                    <div class="col-sm-12 d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center">
                        <mat-icon class="mr-2 back-arrow" (click)="back()">arrow_back</mat-icon>

                        <nav class="navbar navbar-expand-sm ml-3 m-navbar">
                          <ul class="navbar-nav">
                            <li class="nav-item">
                              <a
                                class="nav-link active"
                                [ngClass]="{ active: currentDiv === 'details' }"
                                (click)="scrollTo('details')"
                                >Property Details</a
                              >
                            </li>
                            <li class="nav-item">
                              <a
                                class="nav-link"
                                [ngClass]="{ active: currentDiv === 'compare' }"
                                (click)="scrollTo('compare')"
                                >Comparables</a
                              >
                            </li>
                            <li class="nav-item" *ngIf="cmaViewDetails?.reportCategory != 'smartReport'">
                              <a
                                class="nav-link"
                                [ngClass]="{ active: currentDiv === 'valuation' }"
                                (click)="scrollTo('valuation')"
                                >Valuation</a
                              >
                            </li>
                            <li class="nav-item">
                              <a
                                class="nav-link"
                                [ngClass]="{ active: currentDiv === 'cma-trends' }"
                                (click)="scrollTo('cma-trends')"
                                >Trends</a
                              >
                            </li>
                            <li class="nav-item">
                              <a
                                class="nav-link"
                                [ngClass]="{ active: currentDiv === 'more' }"
                                (click)="scrollTo('more')"
                                >More</a
                              >
                            </li>
                          </ul>
                        </nav>
                      </div>

                      <div class="d-flex">
                        <div class="agent" *ngIf="this.cmaViewDetails?.reportCategory != 'smartReport'">
                          <img [src]="createdBy?.profileImage || defaultProfileImage" alt="User" class="user-icon" />
                          <div class="agent-details">
                            <strong>{{ createdBy?.firstName }} {{ createdBy?.lastName }} </strong>
                            <p>{{ createdBy?.roles[0] }}</p>
                          </div>
                        </div>

                        <button mat-flat-button class="mr-2 play-icon" color="primary">
                          <mat-icon [matTooltip]="'Presentation Mode'" (click)="startSlideShow()">play_arrow</mat-icon>
                        </button>
                        <button
                          *ngIf="
                            cmaViewDetails?.createdById == userId && userRole != 'loanOfficer' && userRole != 'investor'
                          "
                          mat-flat-button
                          class="mr-2 play-icon"
                          color="primary"
                        >
                          <mat-icon [matTooltip]="'Mix/Match Comps'" (click)="editCma()">edit</mat-icon>
                        </button>
                        <app-share-cma-report-dialogbox></app-share-cma-report-dialogbox>
                        <button
                          mat-flat-button
                          color="primary"
                          (click)="download()"
                          [pmx-progress-button]="reportsState.isDownloadingReport"
                          *ngIf="
                            !isScreenWidthSmall &&
                            (this.cmaViewDetails?.reportCategory == 'smartReport' ||
                              this.cmaViewDetails?.reportCategory == 'instantCMA')
                          "
                        >
                          Download
                        </button>
                        <button
                          mat-flat-button
                          class="mr-2 play-icon"
                          [pmx-progress-button]="reportsState.isDownloadingReport"
                          *ngIf="
                            isScreenWidthSmall &&
                            (this.cmaViewDetails?.reportCategory == 'smartReport' ||
                              this.cmaViewDetails?.reportCategory == 'instantCMA')
                          "
                          color="primary"
                        >
                          <mat-icon (click)="download()">download</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="scroller">
                  <div class="sectioninfo" id="details" [ngStyle]="onScrollEvent">
                    <app-view-cma-property-details
                      (moveToDiffSection)="scrollTo($event)"
                    ></app-view-cma-property-details>
                  </div>
                  <div class="sectioninfo" id="compare" [ngStyle]="onScrollEvent">
                    <app-view-cma-comparables></app-view-cma-comparables>
                  </div>
                  <div
                    class="sectioninfo"
                    id="valuation"
                    [ngStyle]="onScrollEvent"
                    *ngIf="cmaViewDetails?.reportCategory != 'smartReport'"
                  >
                    <app-view-cma-valuation></app-view-cma-valuation>
                  </div>
                  <div class="sectioninfo" id="cma-trends" [ngStyle]="onScrollEvent">
                    <app-view-cma-trends></app-view-cma-trends>
                  </div>
                  <div class="sectioninfo" id="more" [ngStyle]="onScrollEvent">
                    <app-view-cma-more></app-view-cma-more>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="section-in-progress" *ngIf="cmaState.isLoadingReport && !message">
  <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
  {{ cmaState.loadingMessage }}
</div>

<!-- Fullscreen Slideshow -->
<div *ngIf="showFullScreenSlideShow && !message" class="fullscreen-overlay preview">
  <!-- <button class="exit-btn" (click)="exitSlideShow()">✕ Close</button> -->
  <div class="slideshow-header">
    <button type="button" class="exit-btn" (click)="exitSlideShow()"><mat-icon>close</mat-icon></button>
  </div>

  <!-- <div class="sliding-sheet-header">
    <h4>&nbsp;</h4>
    <button type="button" class="exit-btn" (click)="exitSlideShow()"><mat-icon>close</mat-icon></button>
  </div> -->

  <div class="slide" *ngIf="slideComponents[currentSlideIndex] === 'details'">
    <app-view-cma-property-details></app-view-cma-property-details>
  </div>

  <div class="slide" *ngIf="slideComponents[currentSlideIndex] === 'compare'">
    <app-view-cma-comparables></app-view-cma-comparables>
  </div>

  <div
    class="slide"
    *ngIf="slideComponents[currentSlideIndex] === 'valuation' && cmaViewDetails?.reportCategory != 'smartReport'"
  >
    <app-view-cma-valuation></app-view-cma-valuation>
  </div>

  <div class="slide" *ngIf="slideComponents[currentSlideIndex] === 'cma-trends'">
    <app-view-cma-trends></app-view-cma-trends>
  </div>

  <div class="slide" *ngIf="slideComponents[currentSlideIndex] === 'more'">
    <app-view-cma-more></app-view-cma-more>
  </div>

  <div class="slideshow-nav">
    <button mat-stroked-button (click)="prevSlide()" [disabled]="currentSlideIndex === 0">
      <mat-icon>arrow_back</mat-icon> Previous
    </button>
    <button
      mat-stroked-button
      color="primary"
      (click)="nextSlide()"
      [disabled]="currentSlideIndex === slideComponents.length - 1"
    >
      Next <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</div>

<div class="dash_base" *ngIf="!cmaState.isLoadingReport && message">
  <div class="container px-0 px-md-3 fullHeight">
    <div class="row w-100">
      <section class="col-sm-12 px-1" style="text-align: center">
        <img src="~/../../assets/images/report-not-found.png" width="250" class="img-fluid" style="margin-top: 90px" />

        <h2>{{ message }}</h2>
      </section>
    </div>
  </div>
</div>
<app-view-cma-slide *ngIf="showSlider && !message" (closeSlider)="closeSliderFromChild()"></app-view-cma-slide>
